import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface WrapperProps {
  $bleedY?: boolean;
  $isSmall?: boolean;
  $disablePointerEvents?: boolean;
  $tone?: 'alt' | 'neutral';
  $size?: 'tiny' | 'small' | 'large';
}

export const Wrapper = styled.div<WrapperProps>`
  --notification-size: ${size(3)};
  --notification-font-size: ${(props) => props.theme.font.size.xsmall};
  --notification-gutter: ${size(1)};
  --notification-bg: var(--c-semantic-error-300);
  --notification-fg: var(--c-semantic-error-700);

  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  min-width: var(--notification-size);
  height: var(--notification-size);
  padding: 0 var(--notification-gutter);
  border-radius: calc(var(--notification-size) / 4);
  background-color: var(--notification-bg);
  color: var(--notification-fg);
  font-size: var(--notification-font-size);
  font-weight: var(--font-weight-bold);
  user-select: none;

  ${({ $tone }) =>
    $tone === 'alt'
      ? css`
          --notification-bg: var(--c-semantic-error-500);
          --notification-fg: var(--c-semantic-error-100);
        `
      : $tone === 'neutral'
        ? css`
          --notification-bg: var(--c-semantic-neutral-300);
          --notification-fg: var(--c-semantic-neutral-700);
        `
        : undefined}

  ${({ $size }) =>
    $size === 'tiny'
      ? css`
          --notification-size: ${size(1.5)};

          width: var(--notification-size);
          height: var(--notification-size);
          min-width: 0;
          padding: 0;
          border-radius: 50%;
        `
      : $size === 'small'
        ? css`
          --notification-size: ${size(2)};
          --notification-font-size: ${(props) => props.theme.font.size.xxsmall};
          --notification-gutter: ${size(0.5)};
        `
        : $size === 'large'
          ? css`
          --notification-size: ${size(4)};
          --notification-font-size: ${(props) => props.theme.font.size.regular};
          --notification-gutter: ${size(1.25)};
        `
          : undefined}

  ${({ $disablePointerEvents }) =>
    $disablePointerEvents &&
    css`
      pointer-events: none;
    `}

  ${({ $bleedY }) =>
    $bleedY &&
    css`
      margin-top: calc(var(--notification-size) / -2);
      margin-bottom: calc(var(--notification-size) / -2);
    `}
`;
